import { Controller } from "stimulus";
import { TweenMax, Power2, Elastic } from "gsap"; // Asegúrate de que GSAP esté instalado

export default class extends Controller {
  connect() {
    this.hover = false;
    this.calculatePosition();
    this.attachEventsListener();
  }

  attachEventsListener() {
    window.addEventListener('mousemove', (e) => this.onMouseMove(e));
    window.addEventListener('resize', () => this.calculatePosition());
  }

  calculatePosition() {
    TweenMax.set(this.element, {
      x: 0,
      y: 0,
      scale: 1
    });
    const box = this.element.getBoundingClientRect();
    this.x = box.left + box.width * 0.5;
    this.y = box.top + box.height * 0.5;
    this.width = box.width;
    this.height = box.height;
  }

  onMouseMove(e) {
    const hoverArea = this.hover ? 1.5 : 1.5;
    const x = e.clientX - this.x;
    const y = e.clientY - this.y;
    const distance = Math.sqrt(x * x + y * y);

    if (distance < this.width * hoverArea) {
      this.hover = true;
      this.onHover(e.clientX, e.clientY);
    } else {
      this.onLeave();
      this.hover = false;
    }
  }

  onHover(x, y) {
    TweenMax.to(this.element, 0.4, {
      x: (x - this.x) * 0.4,
      y: (y - this.y) * 0.4,
      scale: 1.15,
      ease: Power2.easeOut
    });
    this.element.style.zIndex = 10;
  }

  onLeave() {
    TweenMax.to(this.element, 0.7, {
      x: 0,
      y: 0,
      scale: 1,
      ease: Elastic.easeOut.config(1.2, 0.4)
    });
    this.element.style.zIndex = 1;
  }
}
